import { createAction, props } from '@ngrx/store';
import { MyBid, MyLockerItem } from '../../types';

export const pullLocker = createAction(
  '[Locker/API] Pull Locker',
  props<{ section: 'live' | 'won' | 'lost' }>()
);

export const pullLockerSucceeded = createAction(
  '[Locker/API] Pull Locker Succeeded',
  props<{ bids: MyLockerItem[]; nextPage: boolean }>()
);

export const pullLockerNextPage = createAction(
  '[Locker/API] Pull Locker Next Page',
  props<{ section: 'live' | 'won' | 'lost'; skip?: number; limit?: number }>()
);

export const pullLockerNextPageSucceeded = createAction(
  '[Locker/API] Pull Locker Next Page Succeeded',
  props<{ nextBids: MyLockerItem[]; nextPage: boolean }>()
);

export const pullLockerFailed = createAction('[Locker/API] Pull Locker Failed');
